import React from 'react';
import { HardDriveDownload, X } from 'lucide-react';
import { useStorageStore } from '../../stores/storageStore.js';

const MESSAGES = {
  unavailable:
    'ذخیره‌سازی آفلاین در این مرورگر در دسترس نیست (مثلاً حالت خصوصی یا محدودیت مرورگر). تبلچرها و جلسه‌های تمرین روی این دستگاه ذخیره نمی‌شوند.',
  quota: 'فضای ذخیره‌سازی این دستگاه پر است؛ برخی تغییرات ذخیره نشدند. چند تبلچر را از کتابخانه حذف کنید.',
  blocked:
    'فرت‌بورد در زبانهٔ دیگری باز است و به‌روزرسانی پایگاه داده را متوقف کرده است. زبانه‌های دیگر را ببندید و صفحه را دوباره بارگذاری کنید.'
} as const;

/** FRE-171: persistent banner when IndexedDB is unavailable, full or blocked. */
export const StorageBanner: React.FC = () => {
  const status = useStorageStore((s) => s.status);
  const dismissed = useStorageStore((s) => s.dismissed);
  const dismiss = useStorageStore((s) => s.dismiss);
  if (status === 'ok') return null;
  const dismissible = status === 'quota';
  if (dismissible && dismissed) return null;
  return (
    <div
      role="alert"
      data-testid="storage-banner"
      data-status={status}
      className="mb-4 flex items-center gap-3 rounded-xl border border-error/30 bg-error/10 p-3 text-sm"
    >
      <HardDriveDownload className="size-5 shrink-0 text-error" />
      <span className="min-w-0 flex-1">{MESSAGES[status]}</span>
      {dismissible && (
        <button type="button" className="btn btn-ghost btn-sm btn-square" onClick={dismiss} aria-label="بستن" data-testid="storage-banner-dismiss">
          <X className="size-4" />
        </button>
      )}
    </div>
  );
};
